import { createSelector } from 'reselect';

// `../utils` is still untyped JS; `convertToSuccessesAndFailures` resolves as `any`.
import { convertToSuccessesAndFailures } from '../utils';

export interface SuccessesAndFailures {
  successes: unknown[];
  failures: Record<string, string>[];
}

export const getSuccessesAndFailures: (
  results?: Record<string, unknown> | null,
) => SuccessesAndFailures = createSelector(
  [(results?: Record<string, unknown> | null) => results ?? null],
  (results) => convertToSuccessesAndFailures(results),
);
